import axios_nomura from './axios-nomura.services';
import axios_test from './axios-mock.services';

export const fetchIpos = async (ipoType) => {
  return await axios_nomura.get(`api/v1/ipo`, { params: { type: ipoType } });
};
